import { useEffect, useRef } from "react";
import { InputForm } from "src/components/common/form/input/InputForm";
import { buttonFormHeightOption, defaultFormText } from "../common";

interface Props {
	value: string;
	setSearch: (search: string) => void;
	onSearch: () => void;
	wrapperOption?: {
		wrapperStyle: string;
		titleStyle: string;
		inputStyle: string;
	};
}

export const SearchForm = (props: Props) => {
	const { 
		value,
		setSearch,
		onSearch,
		wrapperOption = {
			wrapperStyle: "flex flex-1 ",
			titleStyle: "w-[150px] min-w-[150px]",
			inputStyle: "flex-1"
		}
	} = props;

	const searchRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		if (searchRef.current) {
			searchRef.current.focus();
		}
	}, [])

	const handleEnterKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter') {
			onSearch();
		}
	}

	return (
		<div className={`w-full flex items-center gap-[8px] ${wrapperOption.wrapperStyle}`}>
			<InputForm
				title="검색어" 	
				value={value}
				editable={true}
				wrapperOption = {{
					wrapperStyle: "flex-1 mb-[5px]",
					titleStyle: "w-[150px] min-w-[150px]",
					inputStyle: "flex-1"
				}}
				name="search"
				onChange={(e) => setSearch(e.target.value)} 
				onKeyDown={handleEnterKeyDown}
				onLoadFocus={true}
			/>
			<button className={`${buttonFormHeightOption} text-white rounded-[4px] bg-blue-dark px-[16px] font-semibold ml-auto`}
				onClick={onSearch}>
				조회
			</button>
		</div>
	)
}